import { IRoute } from '@/routes';
import paths from '@/routes/paths';
import BrandListPage from './BrandListPage';
import BrandsPage from './BrandsPage';
import LocationListPage from './LocationListPage';

export const gatewayRoutes: IRoute[] = [
  {
    path: paths.BRAND_LIST,
    component: BrandListPage,
  },
  {
    path: paths.BRANDS,
    component: BrandsPage,
  },
  {
    path: paths.LOCATIONS,
    component: LocationListPage,
  },
];

export default gatewayRoutes;
